import type { CreateGoalRequest } from '../services/goalService'

/**
 * The create form's vocabulary and its one mapping to the API (Goals UX pass
 * 2026-09-06). A title is enough; nothing optional is sent when it was not said.
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export type GoalFormData = Record<string, any>

export function goalFormToPayload(form: GoalFormData): CreateGoalRequest {
  const parentId = form.parent_id ? Number(form.parent_id) : null
  const areas: string[] = Array.isArray(form.life_areas) ? form.life_areas.map(String).filter(Boolean) : []
  return {
    title: String(form.title || '').trim(),
    priority: (form.priority || 'medium') as CreateGoalRequest['priority'],
    parent_dream_id: form.parent_type === 'dream' && parentId ? parentId : undefined,
    life_areas: areas.length ? areas : undefined,
    life_area: areas.length ? areas[0] : undefined,
    description: form.description?.trim?.() || undefined,
    success_criteria: form.success_criteria?.trim?.() || undefined,
    target_date: form.target_date ? String(form.target_date).slice(0, 10) : undefined,
  }
}
